import { PrimaryButton } from "components/Buttons";

type SensorHealthEmptyStateProps = {
  online: boolean;
  onStart: () => void;
};

/**
 * Shown before the first check. Boards and sensors are only knowable while a check streams, so the
 * empty state explains that plainly and invites the one action that reveals them.
 */
export const SensorHealthEmptyState = ({ online, onStart }: SensorHealthEmptyStateProps) => (
  <div className="mx-auto max-w-lg rounded-2xl border border-gray-200/80 bg-white px-6 py-12 text-center shadow-sm">
    <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 ring-1 ring-inset ring-primary-200">
      <span className="relative flex h-3 w-3">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-60 motion-reduce:hidden" />
        <span className="relative inline-flex h-3 w-3 rounded-full bg-primary-500" />
      </span>
    </div>
    <h2 className="mt-5 text-base font-semibold text-gray-900">Nothing checked yet</h2>
    <p className="mx-auto mt-2 max-w-md text-sm text-gray-500">
      Boards and sensors are only knowable while a live check is running — nothing is stored between checks. Start one to
      watch them appear as they report.
    </p>
    <div className="mt-6 flex justify-center">
      <PrimaryButton onClick={onStart} disabled={!online}>
        Start check
      </PrimaryButton>
    </div>
    {!online && <p className="mt-3 text-xs text-red-500">The toolbox is offline. It must be online to run a check.</p>}
  </div>
);
